import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
// import firebase from 'firebase';
import VueYouTubeEmbed from 'vue-youtube-embed';
import VueMeta from 'vue-meta';
import VueAnalytics from 'vue-analytics'

Vue.use(VueYouTubeEmbed);
Vue.use(VueMeta);
Vue.use(VueAnalytics,{
	id: 'UA-147387443-1',
	router
})

Vue.config.productionTip = false;

router.beforeEach(function(to, from, next) {
	window.scrollTo(0, 0);
	next();
});

// const initAnonymousUser = () => {
// 	if (firebase.auth().currentUser) return;

// 	firebase.auth().signInAnonymously().catch((error) => {
// 		// eslint-disable-next-line
// 		console.error('Firebase anonymously sign in error, please check Firebase rules', error);
// 	});
// };

new Vue({
	router,
	vuetify,
	// created() {
	// 	initAnonymousUser();
	// },
	render: (h) => h(App)
}).$mount('#app');
